

export class Message {
  constructor(
    public readonly text: string,
    public readonly receivedTs: number,
    public readonly sentTs: number,
    public readonly senderId?: number,
    public readonly sender?: string,
    public readonly subject?: string,
    public readonly localId?: number,
    public read = false
  ) {}

  public get htmlText(): string {
    return this.text?.replace(/(?:\r\n|\r|\n)/g, '<br>')
  }

  public get plainText(): string {
    return this.text?.replace(/<br\s*\/?>/gi, "\n")
  }
}
